<template>
  <div class="d-flex flex-column flex">
    <loader v-if="authLoading" />

    <div class="p-3 p-md-5">
      <div class="card p-0 col-lg-8 offset-lg-2">
          <div class="row no-gutters">
            <div class="col-md-6 r-l" style="">
              <div class="d-flex flex-column h-100">
                <h4 class="m-4 mb-3 text-white">{{ app_name }}</h4>
                <div class="d-flex flex align-items-center justify-content-center">
                  <img src="@/assets/librate-logo.png" width="100%" :alt="$t('message.title')">
                </div>
              </div>
            </div>

            <div class="col-md-6" id="content-body">
              <div class="p-4">
                <h5>{{ $t('message.Login.welcome') }}</h5>
                <p>
                  <small class="text-muted">{{ $t('message.Login.info') }}</small>
                </p>
                <form @submit.prevent="login">
                  <b-form-input
                    v-model="email"
                    :class="errors.first('email')?'is-invalid':''"
                    type="text"
                    placeholder="Enter email"
                    v-validate="'required|email'"
                    data-vv-name="email"
                    class="mb-4"
                    ></b-form-input>

                  <b-form-input
                    v-model="password"
                    :class="errors.first('password')?'is-invalid':''"
                    type="password"
                    placeholder="Enter password"
                    v-validate="'required'"
                    data-vv-name="password"
                    class="mb-4"
                    ></b-form-input>
                  
                  <b-alert v-if="loginError" show variant="danger">{{ $t('message.Login.badCredentials') }}</b-alert>

                  <b-button
                    variant="primary"
                    type="submit"
                    class="w-100"
                  >{{ $t('message.Login.signIn') }}</b-button>
                </form>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTH_REQUEST } from '@/store/actions/auth'
import { mapState } from 'vuex'

export default {
  name: 'login',
  components: {},
  props: [],
  data () {
    return {
      ready: false,
      email: process.env.VUE_APP_LOGIN ? process.env.VUE_APP_LOGIN : '',
      password: process.env.VUE_APP_PASSWORD ? process.env.VUE_APP_PASSWORD : '',
      app_name: process.env.VUE_APP_TITLE,
    }
  },

  computed: {
    loggedIn : function() {
      // return this.$store.getters.isAuthenticated;
    },
    ...mapState({
      authLoading: false, //state => state.auth.status === 'loading',
      loginError: false//state => state.auth.status === 'error',
    }),

    development() {
      return process.env.NODE_ENV == 'development'
    },

    production() {
      return process.env.NODE_ENV == 'production'
    }
  },

  mounted () {
    /*
    this.$store.dispatch('checkAuth').then(() => {
      if (this.isAuthenticated) {
        console.log('ok')
        return this.$router.push('/')
      }

      console.log('nok')

      this.ready = true
    }).catch(e => {
      console.log('other')
      this.ready = true
    })
    */
  },
  
  methods: {
    login() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.$swal({
            title: 'Error!',
            text: this.$t("message.Login.fillRequiredFields"),
            type: 'error',
            confirmButtonText: 'OK'
          });

          this.showValidateErrors = true;
        } else {
          const { email, password } = this

          this.$store.dispatch(AUTH_REQUEST, { email, password })
            .then(response => {
              this.$router.push('/')
            })
            .catch(e => {
console.log(e)
              this.$swal({
                title: 'Error!',
                text: this.$t("message.Login.badCredentials"),
                type: 'error',
                confirmButtonText: 'OK'
              });
            });
        }
      });
    },
  },
}
</script>


<style scoped>
</style>